import { Injectable } from '@angular/core';

export type PortalAnalyticsOutcome = 'started' | 'completed' | 'failed';

@Injectable({ providedIn: 'root' })
export class PortalAnalyticsService {
  track(event: string, properties: Record<string, string | number | boolean | undefined> = {}): void {
    const safeEvent = event.replace(/[^a-z0-9_]/gi, '_').toLowerCase();
    const safeProperties = Object.fromEntries(
      Object.entries(properties)
        .filter(([, value]) => value !== undefined)
        .filter(([key]) => !/name|email|phone|reference|search|query|message|description|file/i.test(key)),
    );

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('cargomate:portal-analytics', {
        detail: { event: safeEvent, properties: safeProperties },
      }));
      const gtag = (window as Window & { gtag?: (...args: unknown[]) => void }).gtag;
      gtag?.('event', safeEvent, safeProperties);
    }
  }
}
